/**
 * User: v.nazarova
 * Date: 13.02.2025
 */

import React, { useEffect, useState } from 'external/react';
import PropTypes from 'external/prop-types';
import { translation, AppContext } from 'plugin/liferay-widgets-react-web';
// import { getEventType } from '../../utils/event-type-util';
import { NewValueTd, OldValueTd, PropertyTd } from './TableElems';
import { getTitleStore } from '../../stores/StoreFactory';
import TitleActions from '../../actions/TitleActions';

const TitleStore = getTitleStore(AppContext);

const SiteTeamRenderer = (teamId) => {
    const [ team, setTeam ] = useState();
    const titleKey = `Team-${teamId}`;

    if (!teamId) {
        return '---';
    }

    const requestTitle = () => {
        TitleActions.missingTitles([ titleKey ]);
    };

    useEffect(() => {
        const titleKey = `Team-${teamId}`;
        const subscription = TitleStore.addListener(() => {
            setTeam(TitleStore.getTitleFromKey(titleKey));
        });

        if (!team) {
            requestTitle();
        }

        return () => {
            if (subscription) {
                subscription.remove();
            }
        };
    }, [ teamId ]);

    return team;
};

const DEFAULT_PROPNAME = 'teamId';
const DEFAULT_LABEL = 'Team';
const DefaultTextRenderer = ({ value }) => value || '---';

export const ChangeRecordSiteTeamRenderer = ({
    changeRecord, propName = DEFAULT_PROPNAME, label = DEFAULT_LABEL
}) => {
    const { changes } = changeRecord;
    const change = changes[propName];

    if (!change) {
        return null;
    }

    const { oldValue, newValue } = change;
    const teamOld = SiteTeamRenderer(oldValue);
    const teamNew = SiteTeamRenderer(newValue);

    return (
        <tr>
            <PropertyTd>
                {label || translation.trans(propName)}
            </PropertyTd>

            <OldValueTd>
                <DefaultTextRenderer value={teamOld}/>
            </OldValueTd>

            <NewValueTd>
                <DefaultTextRenderer value={teamNew}/>
            </NewValueTd>
        </tr>
    );
};

ChangeRecordSiteTeamRenderer.propTypes = {
    changeRecord: PropTypes.object,
    propName: PropTypes.string,
    label: PropTypes.string,
};



// WEBPACK FOOTER //
// ./js/components/ChangeRecords/ChangeRecordSiteTeamRenderer.jsx